import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "excerpt-block" }
const _hoisted_2 = { class: "excerpt-block__content" }
const _hoisted_3 = { class: "excerpt-block__text" }
const _hoisted_4 = { class: "excerpt-block__metadata-block" }
const _hoisted_5 = { class: "excerpt-block__metadata" }
const _hoisted_6 = {
  crossorigin: "anonymous",
  class: "excerpt-block__image excerpt-block__image--small-screen",
  alt: ""
}

import { onBeforeMount, ref } from 'vue'

import { ExcerptView } from '@/models/excerpt'
import { platform } from '@/services/platform'
import { isSafari as _isSafari } from '@/helpers/userAgent'

import BookCover from '@/app/components/book/card/BookCover.vue'
import BookCardBackground from '@/app/components/book/card/BookCardBackground.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExcerptBlock',
  props: {
    view: {}
  },
  setup(__props: any) {



const isSafari = ref(false)

onBeforeMount(async () => {
  isSafari.value = (await platform.isIOS()) || _isSafari()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: __props.view.excerptRoute,
      class: _normalizeClass(["excerpt-block__inner", { 'excerpt-block__inner--safari': isSafari.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.view.trackExcerptClick())),
      onMouseup: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (__props.view.trackExcerptClick()), ["middle"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "excerpt-block__quote-icon-block" }, [
            _createElementVNode("span", { class: "iconfont iquote excerpt-block__quote-icon" })
          ], -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.view.data.excerpt_text), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.view.data.doc_title) + " • " + _toDisplayString(__props.view.data.author), 1),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "iconfont iarrow-long-right excerpt-block__open-icon" }, null, -1))
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_directive_lazy, { src: __props.view.data.cover_image }]
            ])
          ])
        ]),
        _createVNode(BookCover, {
          doc: __props.view.coverData,
          class: "excerpt-block__image excerpt-block__image--large-screen"
        }, null, 8, ["doc"]),
        (!isSafari.value)
          ? (_openBlock(), _createBlock(BookCardBackground, {
              key: 0,
              class: "excerpt-block__background",
              doc: __props.view.coverData
            }, null, 8, ["doc"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}
}

})